import { cn } from "./cn";

/**
 * Die Hausmarke — die Zeichnung selbst, nicht die Datei.
 *
 * Als Pfad im Quelltext und nicht als `<img src="…svg">`, aus zwei
 * Gruenden: sie faerbt sich ueber `currentColor` mit dem Umfeld
 * (helle Leiste, dunkler Anmeldegrund, invertierter Knopf) und sie
 * ist beim ersten Bild da, ohne eine zweite Anfrage. Fuer den Druck
 * und fuer Dritte liegt die Datei weiter unter
 * `public/ansichtssache-mark.svg`.
 */
export function Mark({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 100 57.6"
      fill="currentColor"
      role="img"
      aria-label="Ansichtssache"
      className={cn("h-5 w-auto", className)}
      {...props}
    >
      <polygon points="61.9,23.2 100,1.6 99.1,0 61,21.5 50,2.6 28.4,39.9 0,56 0.9,57.6 29.5,41.4 72.5,41.4" />
    </svg>
  );
}

/**
 * Marke und Name nebeneinander — fuer Koepfe, in denen beides
 * Platz hat. Der Name steht als Text da und nicht als Teil der
 * Zeichnung, damit er sich suchen, vorlesen und kopieren laesst.
 */
export function Wordmark({
  suffix = "Agent",
  className,
}: {
  /** Was hinter dem Hausnamen steht: „Agent“, „Asset Management“, nichts. */
  suffix?: string | null;
  className?: string;
}) {
  return (
    <span className={cn("inline-flex items-baseline gap-2.5", className)}>
      <Mark className="h-4 translate-y-px" />
      <span className="text-heading-sm tracking-tight">
        Ansichtssache
        {suffix ? (
          <span className="text-text-tertiary font-normal"> {suffix}</span>
        ) : null}
      </span>
    </span>
  );
}
